module.exports = __webpack_public_path__ + "static/media/yow.b87ef3c5.PNG";